import React from "react";

// @ts-ignore
import styles from "./VenuesCarousel.module.sass"
import { Venue } from "../../../../../types/venue";
import { OrderModeType } from "../../../../../types/orders";
import VenuesList from "../../../VenuesList/VenuesList";

type Props = {
  id: string,
  title: string,
  description: string,
  venues: Venue[],
  onVenueClick: (event: any, venue: Venue) => void,
  orderMode: OrderModeType,
}

const VenuesCarousel = ({ id, title, orderMode, description, venues, onVenueClick }: Props) => {

  if (venues.length === 0) {
    return null
  }

  return (
    <div data-test-id={`venues-carousel-${id}`}>
      <div className={styles.title}>{title}</div>
      <div className={styles.description}>{description}</div>
      <VenuesList
        orderMode={orderMode}
        venues={venues}
        onClick={onVenueClick}
      />
    </div>)
}

export default VenuesCarousel;
